import React from 'react'
import { IconProps } from '../types'

export default function UpArrowIcon({
    className = 'h-4 w-4',
    fill = 'currentColor',
    ...props
}: IconProps) {
    return (
        <svg
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M2.35729 0.664692C2.46056 0.55924 2.6006 0.5 2.74662 0.5C2.89264 0.5 3.03268 0.55924 3.13595 0.664692L5.33865 2.91469C5.43896 3.02078 5.49447 3.16287 5.49321 3.31036C5.49196 3.45784 5.43404 3.59892 5.33194 3.70322C5.22984 3.80751 5.09173 3.86666 4.94734 3.86795C4.80296 3.86923 4.66385 3.81253 4.56 3.71007L3.29729 2.42025V8.93738C3.29729 9.08656 3.23928 9.22964 3.136 9.33513C3.03273 9.44062 2.89267 9.49988 2.74662 9.49988C2.60057 9.49988 2.4605 9.44062 2.35723 9.33513C2.25396 9.22964 2.19594 9.08656 2.19594 8.93738V2.42025L0.933238 3.71007C0.829379 3.81253 0.690277 3.86923 0.545892 3.86795C0.401506 3.86666 0.263389 3.80751 0.16129 3.70322C0.0591896 3.59892 0.00127549 3.45784 2.0817e-05 3.31036C-0.00123386 3.16287 0.0542712 3.02078 0.154581 2.91469L2.35729 0.664692Z"
                fill={fill}
            />
        </svg>
    )
}
